import React from 'react'
import { Card, CardContent } from './ui/card'
import { PaginationWithLinks } from './Common/Pagination'
import { useSidebar } from './ui/sidebar'

const BodyCard = ({ children,className='' }) => {
    const { open } = useSidebar()
    return (
        <div className="p-1" style={{ height: 'calc(100vh - 97px)' }}>
            <Card
                className={`h-full overflow-card-scroll w-full px-2 py-2 m-0 overflow-auto`+className}
                style={{
                    maxWidth: open ? 'calc(100vw - var(--sidebar-width) - 8px)' : 'calc(100vw - 8px)',
                    width: open ? 'calc(100vw - var(--sidebar-width) - 8px)' : 'calc(100vw - 8px)',
                    transition: 'width 350ms, max-width 350ms',
                }}
            >
                <CardContent className={"h-full overflow-card-scroll w-full px-2 py-2 m-0 overflow-auto"+className}>
                    {children}
                    
                </CardContent>
            </Card>
        </div>
    )
}

export default BodyCard
